import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolClientStore } from './symbolClient.interface';

export const symbolClientInitialState: ISymbolClientStore = {
  data: {},
  counters: {},
  listNetworkStatus: NetworkStatus.None,
};
